import { render, staticRenderFns } from "./small-form-errors.vue?vue&type=template&id=0777ac81&"
import script from "./small-form-errors.vue?vue&type=script&lang=js&"
export * from "./small-form-errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports